/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetupRouteImport } from './routes/_setup'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SetupRegisterStepsRouteImport } from './routes/_setup/register-steps'
import { Route as PublicImpressumRouteImport } from './routes/_public/impressum'
import { Route as PublicDatenschutzRouteImport } from './routes/_public/datenschutz'
import { Route as PublicAgbRouteImport } from './routes/_public/agb'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as PublicHelpRouteRouteImport } from './routes/_public/help/route'
import { Route as AppMessengerRouteRouteImport } from './routes/_app/messenger/route'
import { Route as PublicHelpIndexRouteImport } from './routes/_public/help/index'
import { Route as AppSearchIndexRouteImport } from './routes/_app/search/index'
import { Route as AppNewsIndexRouteImport } from './routes/_app/news/index'
import { Route as AppMessengerIndexRouteImport } from './routes/_app/messenger/index'
import { Route as AppFriendsIndexRouteImport } from './routes/_app/friends/index'
import { Route as AppFlirtTippsIndexRouteImport } from './routes/_app/flirt-tipps/index'
import { Route as AppFavoritesIndexRouteImport } from './routes/_app/favorites/index'
import { Route as AppCreditsIndexRouteImport } from './routes/_app/credits/index'
import { Route as AppAboutmeIndexRouteImport } from './routes/_app/aboutme/index'
import { Route as PublicProfileNameRouteImport } from './routes/_public/profile/$name'
import { Route as PublicHelpTicketRouteImport } from './routes/_public/help/ticket'
import { Route as PublicHelpFaqRouteImport } from './routes/_public/help/faq'
import { Route as AppMessengerIdRouteImport } from './routes/_app/messenger/$id'
import { Route as AppFriendsTabRouteImport } from './routes/_app/friends/$tab'
import { Route as AppFlirtTippsSlugRouteImport } from './routes/_app/flirt-tipps/$slug'
import { Route as AppAboutmeTabRouteImport } from './routes/_app/aboutme/$tab'
import { Route as PublicHelpTicketsIndexRouteImport } from './routes/_public/help/tickets/index'
import { Route as PublicLoginMailTokenRouteImport } from './routes/_public/login/mail/$token'
import { Route as PublicHelpTicketsIdRouteImport } from './routes/_public/help/tickets/$id'
import { Route as PublicRegisterAfterCustomerTokenRouteImport } from './routes/_public/register/after/$customer/$token'
import { Route as PublicMailUnsubscribeCustomerTypeTokenRouteImport } from './routes/_public/mail/unsubscribe/$customer/$type/$token'

const SetupRoute = SetupRouteImport.update({
  id: '/_setup',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRegisterStepsRoute = SetupRegisterStepsRouteImport.update({
  id: '/register-steps',
  path: '/register-steps',
  getParentRoute: () => SetupRoute,
} as any)
const PublicImpressumRoute = PublicImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => PublicRoute,
} as any)
const PublicDatenschutzRoute = PublicDatenschutzRouteImport.update({
  id: '/datenschutz',
  path: '/datenschutz',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAgbRoute = PublicAgbRouteImport.update({
  id: '/agb',
  path: '/agb',
  getParentRoute: () => PublicRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const PublicHelpRouteRoute = PublicHelpRouteRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => PublicRoute,
} as any)
const AppMessengerRouteRoute = AppMessengerRouteRouteImport.update({
  id: '/messenger',
  path: '/messenger',
  getParentRoute: () => AppRoute,
} as any)
const PublicHelpIndexRoute = PublicHelpIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicHelpRouteRoute,
} as any)
const AppSearchIndexRoute = AppSearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => AppRoute,
} as any)
const AppNewsIndexRoute = AppNewsIndexRouteImport.update({
  id: '/news/',
  path: '/news/',
  getParentRoute: () => AppRoute,
} as any)
const AppMessengerIndexRoute = AppMessengerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMessengerRouteRoute,
} as any)
const AppFriendsIndexRoute = AppFriendsIndexRouteImport.update({
  id: '/friends/',
  path: '/friends/',
  getParentRoute: () => AppRoute,
} as any)
const AppFlirtTippsIndexRoute = AppFlirtTippsIndexRouteImport.update({
  id: '/flirt-tipps/',
  path: '/flirt-tipps/',
  getParentRoute: () => AppRoute,
} as any)
const AppFavoritesIndexRoute = AppFavoritesIndexRouteImport.update({
  id: '/favorites/',
  path: '/favorites/',
  getParentRoute: () => AppRoute,
} as any)
const AppCreditsIndexRoute = AppCreditsIndexRouteImport.update({
  id: '/credits/',
  path: '/credits/',
  getParentRoute: () => AppRoute,
} as any)
const AppAboutmeIndexRoute = AppAboutmeIndexRouteImport.update({
  id: '/aboutme/',
  path: '/aboutme/',
  getParentRoute: () => AppRoute,
} as any)
const PublicProfileNameRoute = PublicProfileNameRouteImport.update({
  id: '/profile/$name',
  path: '/profile/$name',
  getParentRoute: () => PublicRoute,
} as any)
const PublicHelpTicketRoute = PublicHelpTicketRouteImport.update({
  id: '/ticket',
  path: '/ticket',
  getParentRoute: () => PublicHelpRouteRoute,
} as any)
const PublicHelpFaqRoute = PublicHelpFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => PublicHelpRouteRoute,
} as any)
const AppMessengerIdRoute = AppMessengerIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppMessengerRouteRoute,
} as any)
const AppFriendsTabRoute = AppFriendsTabRouteImport.update({
  id: '/friends/$tab',
  path: '/friends/$tab',
  getParentRoute: () => AppRoute,
} as any)
const AppFlirtTippsSlugRoute = AppFlirtTippsSlugRouteImport.update({
  id: '/flirt-tipps/$slug',
  path: '/flirt-tipps/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppAboutmeTabRoute = AppAboutmeTabRouteImport.update({
  id: '/aboutme/$tab',
  path: '/aboutme/$tab',
  getParentRoute: () => AppRoute,
} as any)
const PublicHelpTicketsIndexRoute = PublicHelpTicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => PublicHelpRouteRoute,
} as any)
const PublicLoginMailTokenRoute = PublicLoginMailTokenRouteImport.update({
  id: '/login/mail/$token',
  path: '/login/mail/$token',
  getParentRoute: () => PublicRoute,
} as any)
const PublicHelpTicketsIdRoute = PublicHelpTicketsIdRouteImport.update({
  id: '/tickets/$id',
  path: '/tickets/$id',
  getParentRoute: () => PublicHelpRouteRoute,
} as any)
const PublicRegisterAfterCustomerTokenRoute =
  PublicRegisterAfterCustomerTokenRouteImport.update({
    id: '/register/after/$customer/$token',
    path: '/register/after/$customer/$token',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicMailUnsubscribeCustomerTypeTokenRoute =
  PublicMailUnsubscribeCustomerTypeTokenRouteImport.update({
    id: '/mail/unsubscribe/$customer/$type/$token',
    path: '/mail/unsubscribe/$customer/$type/$token',
    getParentRoute: () => PublicRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/messenger': typeof AppMessengerRouteRouteWithChildren
  '/help': typeof PublicHelpRouteRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/agb': typeof PublicAgbRoute
  '/datenschutz': typeof PublicDatenschutzRoute
  '/impressum': typeof PublicImpressumRoute
  '/register-steps': typeof SetupRegisterStepsRoute
  '/aboutme/$tab': typeof AppAboutmeTabRoute
  '/flirt-tipps/$slug': typeof AppFlirtTippsSlugRoute
  '/friends/$tab': typeof AppFriendsTabRoute
  '/messenger/$id': typeof AppMessengerIdRoute
  '/help/faq': typeof PublicHelpFaqRoute
  '/help/ticket': typeof PublicHelpTicketRoute
  '/profile/$name': typeof PublicProfileNameRoute
  '/aboutme/': typeof AppAboutmeIndexRoute
  '/credits/': typeof AppCreditsIndexRoute
  '/favorites/': typeof AppFavoritesIndexRoute
  '/flirt-tipps/': typeof AppFlirtTippsIndexRoute
  '/friends/': typeof AppFriendsIndexRoute
  '/messenger/': typeof AppMessengerIndexRoute
  '/news/': typeof AppNewsIndexRoute
  '/search/': typeof AppSearchIndexRoute
  '/help/': typeof PublicHelpIndexRoute
  '/help/tickets/$id': typeof PublicHelpTicketsIdRoute
  '/login/mail/$token': typeof PublicLoginMailTokenRoute
  '/help/tickets/': typeof PublicHelpTicketsIndexRoute
  '/register/after/$customer/$token': typeof PublicRegisterAfterCustomerTokenRoute
  '/mail/unsubscribe/$customer/$type/$token': typeof PublicMailUnsubscribeCustomerTypeTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/agb': typeof PublicAgbRoute
  '/datenschutz': typeof PublicDatenschutzRoute
  '/impressum': typeof PublicImpressumRoute
  '/register-steps': typeof SetupRegisterStepsRoute
  '/aboutme/$tab': typeof AppAboutmeTabRoute
  '/flirt-tipps/$slug': typeof AppFlirtTippsSlugRoute
  '/friends/$tab': typeof AppFriendsTabRoute
  '/messenger/$id': typeof AppMessengerIdRoute
  '/help/faq': typeof PublicHelpFaqRoute
  '/help/ticket': typeof PublicHelpTicketRoute
  '/profile/$name': typeof PublicProfileNameRoute
  '/aboutme': typeof AppAboutmeIndexRoute
  '/credits': typeof AppCreditsIndexRoute
  '/favorites': typeof AppFavoritesIndexRoute
  '/flirt-tipps': typeof AppFlirtTippsIndexRoute
  '/friends': typeof AppFriendsIndexRoute
  '/messenger': typeof AppMessengerIndexRoute
  '/news': typeof AppNewsIndexRoute
  '/search': typeof AppSearchIndexRoute
  '/help': typeof PublicHelpIndexRoute
  '/help/tickets/$id': typeof PublicHelpTicketsIdRoute
  '/login/mail/$token': typeof PublicLoginMailTokenRoute
  '/help/tickets': typeof PublicHelpTicketsIndexRoute
  '/register/after/$customer/$token': typeof PublicRegisterAfterCustomerTokenRoute
  '/mail/unsubscribe/$customer/$type/$token': typeof PublicMailUnsubscribeCustomerTypeTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_setup': typeof SetupRouteWithChildren
  '/_app/messenger': typeof AppMessengerRouteRouteWithChildren
  '/_public/help': typeof PublicHelpRouteRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_public/agb': typeof PublicAgbRoute
  '/_public/datenschutz': typeof PublicDatenschutzRoute
  '/_public/impressum': typeof PublicImpressumRoute
  '/_setup/register-steps': typeof SetupRegisterStepsRoute
  '/_app/aboutme/$tab': typeof AppAboutmeTabRoute
  '/_app/flirt-tipps/$slug': typeof AppFlirtTippsSlugRoute
  '/_app/friends/$tab': typeof AppFriendsTabRoute
  '/_app/messenger/$id': typeof AppMessengerIdRoute
  '/_public/help/faq': typeof PublicHelpFaqRoute
  '/_public/help/ticket': typeof PublicHelpTicketRoute
  '/_public/profile/$name': typeof PublicProfileNameRoute
  '/_app/aboutme/': typeof AppAboutmeIndexRoute
  '/_app/credits/': typeof AppCreditsIndexRoute
  '/_app/favorites/': typeof AppFavoritesIndexRoute
  '/_app/flirt-tipps/': typeof AppFlirtTippsIndexRoute
  '/_app/friends/': typeof AppFriendsIndexRoute
  '/_app/messenger/': typeof AppMessengerIndexRoute
  '/_app/news/': typeof AppNewsIndexRoute
  '/_app/search/': typeof AppSearchIndexRoute
  '/_public/help/': typeof PublicHelpIndexRoute
  '/_public/help/tickets/$id': typeof PublicHelpTicketsIdRoute
  '/_public/login/mail/$token': typeof PublicLoginMailTokenRoute
  '/_public/help/tickets/': typeof PublicHelpTicketsIndexRoute
  '/_public/register/after/$customer/$token': typeof PublicRegisterAfterCustomerTokenRoute
  '/_public/mail/unsubscribe/$customer/$type/$token': typeof PublicMailUnsubscribeCustomerTypeTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/messenger'
    | '/help'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/agb'
    | '/datenschutz'
    | '/impressum'
    | '/register-steps'
    | '/aboutme/$tab'
    | '/flirt-tipps/$slug'
    | '/friends/$tab'
    | '/messenger/$id'
    | '/help/faq'
    | '/help/ticket'
    | '/profile/$name'
    | '/aboutme/'
    | '/credits/'
    | '/favorites/'
    | '/flirt-tipps/'
    | '/friends/'
    | '/messenger/'
    | '/news/'
    | '/search/'
    | '/help/'
    | '/help/tickets/$id'
    | '/login/mail/$token'
    | '/help/tickets/'
    | '/register/after/$customer/$token'
    | '/mail/unsubscribe/$customer/$type/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/agb'
    | '/datenschutz'
    | '/impressum'
    | '/register-steps'
    | '/aboutme/$tab'
    | '/flirt-tipps/$slug'
    | '/friends/$tab'
    | '/messenger/$id'
    | '/help/faq'
    | '/help/ticket'
    | '/profile/$name'
    | '/aboutme'
    | '/credits'
    | '/favorites'
    | '/flirt-tipps'
    | '/friends'
    | '/messenger'
    | '/news'
    | '/search'
    | '/help'
    | '/help/tickets/$id'
    | '/login/mail/$token'
    | '/help/tickets'
    | '/register/after/$customer/$token'
    | '/mail/unsubscribe/$customer/$type/$token'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_public'
    | '/_setup'
    | '/_app/messenger'
    | '/_public/help'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/register'
    | '/_public/agb'
    | '/_public/datenschutz'
    | '/_public/impressum'
    | '/_setup/register-steps'
    | '/_app/aboutme/$tab'
    | '/_app/flirt-tipps/$slug'
    | '/_app/friends/$tab'
    | '/_app/messenger/$id'
    | '/_public/help/faq'
    | '/_public/help/ticket'
    | '/_public/profile/$name'
    | '/_app/aboutme/'
    | '/_app/credits/'
    | '/_app/favorites/'
    | '/_app/flirt-tipps/'
    | '/_app/friends/'
    | '/_app/messenger/'
    | '/_app/news/'
    | '/_app/search/'
    | '/_public/help/'
    | '/_public/help/tickets/$id'
    | '/_public/login/mail/$token'
    | '/_public/help/tickets/'
    | '/_public/register/after/$customer/$token'
    | '/_public/mail/unsubscribe/$customer/$type/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  SetupRoute: typeof SetupRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_setup': {
      id: '/_setup'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_setup/register-steps': {
      id: '/_setup/register-steps'
      path: '/register-steps'
      fullPath: '/register-steps'
      preLoaderRoute: typeof SetupRegisterStepsRouteImport
      parentRoute: typeof SetupRoute
    }
    '/_public/impressum': {
      id: '/_public/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof PublicImpressumRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/datenschutz': {
      id: '/_public/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof PublicDatenschutzRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/agb': {
      id: '/_public/agb'
      path: '/agb'
      fullPath: '/agb'
      preLoaderRoute: typeof PublicAgbRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/help': {
      id: '/_public/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof PublicHelpRouteRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/messenger': {
      id: '/_app/messenger'
      path: '/messenger'
      fullPath: '/messenger'
      preLoaderRoute: typeof AppMessengerRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/help/': {
      id: '/_public/help/'
      path: '/'
      fullPath: '/help/'
      preLoaderRoute: typeof PublicHelpIndexRouteImport
      parentRoute: typeof PublicHelpRouteRoute
    }
    '/_app/search/': {
      id: '/_app/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof AppSearchIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/news/': {
      id: '/_app/news/'
      path: '/news'
      fullPath: '/news/'
      preLoaderRoute: typeof AppNewsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messenger/': {
      id: '/_app/messenger/'
      path: '/'
      fullPath: '/messenger/'
      preLoaderRoute: typeof AppMessengerIndexRouteImport
      parentRoute: typeof AppMessengerRouteRoute
    }
    '/_app/friends/': {
      id: '/_app/friends/'
      path: '/friends'
      fullPath: '/friends/'
      preLoaderRoute: typeof AppFriendsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/flirt-tipps/': {
      id: '/_app/flirt-tipps/'
      path: '/flirt-tipps'
      fullPath: '/flirt-tipps/'
      preLoaderRoute: typeof AppFlirtTippsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/favorites/': {
      id: '/_app/favorites/'
      path: '/favorites'
      fullPath: '/favorites/'
      preLoaderRoute: typeof AppFavoritesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/credits/': {
      id: '/_app/credits/'
      path: '/credits'
      fullPath: '/credits/'
      preLoaderRoute: typeof AppCreditsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/aboutme/': {
      id: '/_app/aboutme/'
      path: '/aboutme'
      fullPath: '/aboutme/'
      preLoaderRoute: typeof AppAboutmeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/profile/$name': {
      id: '/_public/profile/$name'
      path: '/profile/$name'
      fullPath: '/profile/$name'
      preLoaderRoute: typeof PublicProfileNameRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/help/ticket': {
      id: '/_public/help/ticket'
      path: '/ticket'
      fullPath: '/help/ticket'
      preLoaderRoute: typeof PublicHelpTicketRouteImport
      parentRoute: typeof PublicHelpRouteRoute
    }
    '/_public/help/faq': {
      id: '/_public/help/faq'
      path: '/faq'
      fullPath: '/help/faq'
      preLoaderRoute: typeof PublicHelpFaqRouteImport
      parentRoute: typeof PublicHelpRouteRoute
    }
    '/_app/messenger/$id': {
      id: '/_app/messenger/$id'
      path: '/$id'
      fullPath: '/messenger/$id'
      preLoaderRoute: typeof AppMessengerIdRouteImport
      parentRoute: typeof AppMessengerRouteRoute
    }
    '/_app/friends/$tab': {
      id: '/_app/friends/$tab'
      path: '/friends/$tab'
      fullPath: '/friends/$tab'
      preLoaderRoute: typeof AppFriendsTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/flirt-tipps/$slug': {
      id: '/_app/flirt-tipps/$slug'
      path: '/flirt-tipps/$slug'
      fullPath: '/flirt-tipps/$slug'
      preLoaderRoute: typeof AppFlirtTippsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/aboutme/$tab': {
      id: '/_app/aboutme/$tab'
      path: '/aboutme/$tab'
      fullPath: '/aboutme/$tab'
      preLoaderRoute: typeof AppAboutmeTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/help/tickets/': {
      id: '/_public/help/tickets/'
      path: '/tickets'
      fullPath: '/help/tickets/'
      preLoaderRoute: typeof PublicHelpTicketsIndexRouteImport
      parentRoute: typeof PublicHelpRouteRoute
    }
    '/_public/login/mail/$token': {
      id: '/_public/login/mail/$token'
      path: '/login/mail/$token'
      fullPath: '/login/mail/$token'
      preLoaderRoute: typeof PublicLoginMailTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/help/tickets/$id': {
      id: '/_public/help/tickets/$id'
      path: '/tickets/$id'
      fullPath: '/help/tickets/$id'
      preLoaderRoute: typeof PublicHelpTicketsIdRouteImport
      parentRoute: typeof PublicHelpRouteRoute
    }
    '/_public/register/after/$customer/$token': {
      id: '/_public/register/after/$customer/$token'
      path: '/register/after/$customer/$token'
      fullPath: '/register/after/$customer/$token'
      preLoaderRoute: typeof PublicRegisterAfterCustomerTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/mail/unsubscribe/$customer/$type/$token': {
      id: '/_public/mail/unsubscribe/$customer/$type/$token'
      path: '/mail/unsubscribe/$customer/$type/$token'
      fullPath: '/mail/unsubscribe/$customer/$type/$token'
      preLoaderRoute: typeof PublicMailUnsubscribeCustomerTypeTokenRouteImport
      parentRoute: typeof PublicRoute
    }
  }
}

interface AppMessengerRouteRouteChildren {
  AppMessengerIdRoute: typeof AppMessengerIdRoute
  AppMessengerIndexRoute: typeof AppMessengerIndexRoute
}

const AppMessengerRouteRouteChildren: AppMessengerRouteRouteChildren = {
  AppMessengerIdRoute: AppMessengerIdRoute,
  AppMessengerIndexRoute: AppMessengerIndexRoute,
}

const AppMessengerRouteRouteWithChildren =
  AppMessengerRouteRoute._addFileChildren(AppMessengerRouteRouteChildren)

interface AppRouteChildren {
  AppMessengerRouteRoute: typeof AppMessengerRouteRouteWithChildren
  AppAboutmeTabRoute: typeof AppAboutmeTabRoute
  AppFlirtTippsSlugRoute: typeof AppFlirtTippsSlugRoute
  AppFriendsTabRoute: typeof AppFriendsTabRoute
  AppAboutmeIndexRoute: typeof AppAboutmeIndexRoute
  AppCreditsIndexRoute: typeof AppCreditsIndexRoute
  AppFavoritesIndexRoute: typeof AppFavoritesIndexRoute
  AppFlirtTippsIndexRoute: typeof AppFlirtTippsIndexRoute
  AppFriendsIndexRoute: typeof AppFriendsIndexRoute
  AppNewsIndexRoute: typeof AppNewsIndexRoute
  AppSearchIndexRoute: typeof AppSearchIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppMessengerRouteRoute: AppMessengerRouteRouteWithChildren,
  AppAboutmeTabRoute: AppAboutmeTabRoute,
  AppFlirtTippsSlugRoute: AppFlirtTippsSlugRoute,
  AppFriendsTabRoute: AppFriendsTabRoute,
  AppAboutmeIndexRoute: AppAboutmeIndexRoute,
  AppCreditsIndexRoute: AppCreditsIndexRoute,
  AppFavoritesIndexRoute: AppFavoritesIndexRoute,
  AppFlirtTippsIndexRoute: AppFlirtTippsIndexRoute,
  AppFriendsIndexRoute: AppFriendsIndexRoute,
  AppNewsIndexRoute: AppNewsIndexRoute,
  AppSearchIndexRoute: AppSearchIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicHelpRouteRouteChildren {
  PublicHelpFaqRoute: typeof PublicHelpFaqRoute
  PublicHelpTicketRoute: typeof PublicHelpTicketRoute
  PublicHelpIndexRoute: typeof PublicHelpIndexRoute
  PublicHelpTicketsIdRoute: typeof PublicHelpTicketsIdRoute
  PublicHelpTicketsIndexRoute: typeof PublicHelpTicketsIndexRoute
}

const PublicHelpRouteRouteChildren: PublicHelpRouteRouteChildren = {
  PublicHelpFaqRoute: PublicHelpFaqRoute,
  PublicHelpTicketRoute: PublicHelpTicketRoute,
  PublicHelpIndexRoute: PublicHelpIndexRoute,
  PublicHelpTicketsIdRoute: PublicHelpTicketsIdRoute,
  PublicHelpTicketsIndexRoute: PublicHelpTicketsIndexRoute,
}

const PublicHelpRouteRouteWithChildren = PublicHelpRouteRoute._addFileChildren(
  PublicHelpRouteRouteChildren,
)

interface PublicRouteChildren {
  PublicHelpRouteRoute: typeof PublicHelpRouteRouteWithChildren
  PublicAgbRoute: typeof PublicAgbRoute
  PublicDatenschutzRoute: typeof PublicDatenschutzRoute
  PublicImpressumRoute: typeof PublicImpressumRoute
  PublicProfileNameRoute: typeof PublicProfileNameRoute
  PublicLoginMailTokenRoute: typeof PublicLoginMailTokenRoute
  PublicRegisterAfterCustomerTokenRoute: typeof PublicRegisterAfterCustomerTokenRoute
  PublicMailUnsubscribeCustomerTypeTokenRoute: typeof PublicMailUnsubscribeCustomerTypeTokenRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicHelpRouteRoute: PublicHelpRouteRouteWithChildren,
  PublicAgbRoute: PublicAgbRoute,
  PublicDatenschutzRoute: PublicDatenschutzRoute,
  PublicImpressumRoute: PublicImpressumRoute,
  PublicProfileNameRoute: PublicProfileNameRoute,
  PublicLoginMailTokenRoute: PublicLoginMailTokenRoute,
  PublicRegisterAfterCustomerTokenRoute: PublicRegisterAfterCustomerTokenRoute,
  PublicMailUnsubscribeCustomerTypeTokenRoute:
    PublicMailUnsubscribeCustomerTypeTokenRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface SetupRouteChildren {
  SetupRegisterStepsRoute: typeof SetupRegisterStepsRoute
}

const SetupRouteChildren: SetupRouteChildren = {
  SetupRegisterStepsRoute: SetupRegisterStepsRoute,
}

const SetupRouteWithChildren = SetupRoute._addFileChildren(SetupRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  SetupRoute: SetupRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
